import moment from 'moment'
import getAppInfo from '@/utils/from'

const airline = window.__MICRO_ROOT__?.airline
// const maxCount = 18
const minCount = 1
const seatMax = 9

// 成人与婴儿加儿童的比例关系
// NOTE: JD 和 UQ 特殊处理
let ratio = 3
const ratioMap = {
  UQ: 2,
  JD: 8,
  Y8: 8
}

ratio = ratioMap[airline] ?? ratio

/**
 * 旅客编辑校验
 * @param {Array} traveller 旅客列表
 * @param {String} action 'add'/'reduce'
 * @param {Object} passenger 操作对象旅客信息
 * @param {Date} adultDate 当前航班日期达到成人标准的日期
 * @param {*} vm 获取组件实例参数以支持个性化校验
 * @returns {Object}
 */
export default function (traveller = [], action, passenger, vm) {
  const { birthday } = passenger
  const { adultDate } = vm
  let { isSelfAirline } = vm
  // NOTE: 后续其他家可能同步互售的配置
  if (['JD', 'Y8'].includes(airline)) {
    ratio = isSelfAirline ? ratio : 2
  } else {
    isSelfAirline = true
  }

  const type = passenger.passengerType
  let total = 0
  let adtCount = 0
  let guardianCount = 0
  let cnnCount = 0
  let infCount = 0

  // 用于删除校验
  const isAdult = adultDate && moment(birthday).valueOf() <= adultDate.valueOf()

  traveller.forEach(item => {
    total++
    if (item.passengerType === 'ADT') {
      adtCount++
      if (adultDate && moment(item.birthday).valueOf() <= adultDate.valueOf()) {
        guardianCount++
      }
    }
    if (item.passengerType === 'CHD') {
      cnnCount++
    }
    if (item.passengerType === 'INF') {
      infCount++
    }
  })

  if (action === 'add') {
    if (adtCount + cnnCount >= seatMax && type !== 'INF') {
      return {
        value: false,
        message: `成人+儿童旅客数量最多为${seatMax}名`
      }
    }
    if (guardianCount <= infCount && type === 'INF') {
      let message = `每名成人（年满18周岁）仅可携带1名婴儿，超出婴儿需致电${getAppInfo()?.hotline}购票。`
      if (['JD', 'Y8'].includes(airline)) {
        if (isSelfAirline) {
          if (airline === 'JD') {
            message = `每名年满18周岁且具有完全民事行为能力的成人可携带一名婴儿同行，超出婴儿请致电${getAppInfo()?.name}客服热线${getAppInfo()?.hotline}咨询购票。`
          } else {
            message = `每名年满18周岁且具有完全民事行为能力的成人可携带一名婴儿同行，如有第二名婴儿同行，在婴儿旅客父母、监护人或者指定的护理人员提供经局方批准的儿童限制装置时，可按照占座儿童购票，详情请联系客服${getAppInfo()?.hotline}处理。您输入的旅客信息不符合要求，请修改旅客信息后重新预订。`
          }
        } else {
          message = `预订非${getAppInfo()?.name}实际承运的国内航班，每名年满18周岁的成人最多可携带2名儿童及1名婴儿。您输入的旅客信息不符合要求，请修改信息后重新预订。`
        }
      }
      return {
        value: false,
        message
      }
    }
    if (!isSelfAirline) {
      if (guardianCount * ratio <= cnnCount && (type === 'CHD')) {
        return {
          value: false,
          message: `预订非${getAppInfo()?.name}实际承运的国内航班，每名年满18周岁的成人最多可携带2名儿童及1名婴儿。您输入的旅客信息不符合要求，请修改信息后重新预订。`
        }
      }
    } else {
      if (guardianCount * ratio <= cnnCount + infCount && (type === 'CHD' || type === 'INF')) {
        let message = `请先填写成人乘机人信息`
        if (guardianCount !== 0) {
          message = `儿童数量超过限制，每名成人（年满18周岁）最多携带${ratio}名儿童（包括婴儿）`
        }
        return {
          value: false,
          message
        }
      }
    }
  } else {
    if ((total <= minCount || adtCount <= minCount) && type === 'ADT') {
      return {
        value: false,
        message: '一个订单中至少包含一个成人旅客'
      }
    }
    if (guardianCount * ratio >= cnnCount + infCount && (guardianCount - 1) * ratio < cnnCount + infCount && type === 'ADT' && isAdult) {
      return {
        value: false,
        message: `儿童数量超过限制，1名成人（年满18周岁）最多携带${ratio}名儿童（包括婴儿）`
      }
    }
    if (guardianCount >= infCount && guardianCount - 1 < infCount && type === 'ADT' && isAdult) {
      return {
        value: false,
        message: `1名成人（年满18周岁）仅可携带1名婴儿，超出婴儿需致电${getAppInfo()?.hotline}购票。`
      }
    }
  }
  return {
    value: true
  }
}
